import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import UserSessionsTable from 'components/common/UserSessionsTable';
import SessionFormModal from 'components/common/SessionFormModal';
import SaveCalendarSession from 'components/common/SaveCalendarSession';
import NedCalendar from 'components/common/NedCalendar';
import NoStudioYet from 'components/common/NoStudioYet';
import Modal from 'components/common/Modal';
import Button from 'components/common/Button';
import SectionHeader from 'components/text/SectionHeader';

class AppCalendar extends React.PureComponent {
  state = {
    createModalIsVisible: false,
    saveModalIsVisible: false,
    editSession: null,
  };

  toggleCreate = () => {
    this.setState({ createModalIsVisible: !this.state.createModalIsVisible });
  };

  toggleSave = () => {
    this.setState({ saveModalIsVisible: !this.state.saveModalIsVisible });
  };

  handleEdit = session => {
    this.setState({ editSession: session });
    this.toggleSave();
  };

  render() {
    const { children, currentUser } = this.props;
    const { createModalIsVisible, saveModalIsVisible, editSession } = this.state;
    const noStudioYet = !currentUser || !currentUser.organization || !currentUser.organization._id;

    if (noStudioYet) {
      return <NoStudioYet />;
    }
    return (
      <div>
        {' '}
        <PageContainer>
          <div>
            <div className="flex justify-between" style={{ position: 'relative' }}>
              <SectionHeader>CALENDAR</SectionHeader>
              <Button style={{ position: 'absolute', right: 0 }} onClick={this.toggleCreate}>
                + ADD SESSION
              </Button>
              {/* Force reset to clear form state */}
              {createModalIsVisible && (
                <SessionFormModal
                  triggerType="button"
                  visible={createModalIsVisible}
                  currentUser={this.props.currentUser}
                  sessionTypes={currentUser.organization && currentUser.organization.sessionTypes}
                  buttonProps={{
                    style: { position: 'absolute', right: 0 },
                    onClick: this.toggleCreate,
                  }}
                />
              )}
            </div>
            <NedCalendar {...this.props} />
            <SectionHeader>SESSIONS</SectionHeader>
            {children || (
              <UserSessionsTable
                onEdit={this.handleEdit}
                showCols={
                  this.props.windowWidth > 780
                    ? ['title', 'description', 'category', 'date', 'time', 'client', 'edit', 'delete']
                    : ['category', 'date', 'time', 'client']
                }
              />
            )}
          </div>
        </PageContainer>
        {/* Force re-render to clear form fields */}
        {/* {createModalIsVisible && (
          <Modal visible={createModalIsVisible} footer={null} title="ADD SESSION" onCancel={this.toggleCreate}>
            <div className="flex justify-center align-center mx-auto">
               <CreateCalendarSession
                onCancel={this.toggleCreate}
                sessionTypes={currentUser.organization.sessionTypes}
                onComplete={this.toggleCreate}
              />

            </div>
          </Modal>
        )} */}
        {/* Force re-render to clear form fields */}
        {saveModalIsVisible && (
          <Modal visible={saveModalIsVisible} footer={null} title="EDIT SESSION" onCancel={this.toggleSave}>
            <div className="flex justify-center align-center mx-auto">
              <SaveCalendarSession
                session={editSession}
                onCancel={this.toggleSave}
                sessionTypes={currentUser.organization.sessionTypes}
                onComplete={this.toggleSave}
              />
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default AppCalendar;



// WEBPACK FOOTER //
// ./src/routes/app-calendar/index.js